import axios from 'axios'

export const getSubscriptionUrl = (params) => {
    return axios.post('/stripe/checkout/sam/plan',params)
}